// hooks/useResolvedId.ts
import { useGlobalSearchParams } from "expo-router";

export function useResolvedId(routeKey: string, provided?: string | string[]) {
  const route = useGlobalSearchParams() as Record<string, string | string[] | undefined>;
  const fromProvided = typeof provided === "string" ? provided : Array.isArray(provided) ? provided[0] : undefined;
  const fromRoute =
    typeof route[routeKey] === "string"
      ? (route[routeKey] as string)
      : Array.isArray(route[routeKey])
        ? (route[routeKey] as string[])[0]
        : undefined;

  return fromProvided ?? fromRoute;
}
